export default "__VITE_ASSET__381c887d__"